import React from 'react';
import { useNavigate } from 'react-router-dom';

const GuestBlockedView = ({ title, description, icon, benefits }) => {
    const navigate = useNavigate();
    return (
        <div className="flex flex-col items-center justify-center min-h-[60vh] p-4 text-center">
            <div className="text-6xl mb-4">{icon}</div>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-2">{title}</h1>
            <p className="text-gray-600 dark:text-gray-400 max-w-md mb-6">{description}</p>
            <div className="bg-white dark:bg-[#1a1a1a] p-6 rounded-xl shadow-lg border border-gray-200 dark:border-gray-800 max-w-md w-full mb-6">
                <h3 className="font-semibold text-gray-900 dark:text-gray-100 mb-3 text-left">Vorteile eines Accounts:</h3>
                <ul className="space-y-2 text-left">
                    {benefits.map((benefit, index) => (
                        <li key={index} className="flex items-start gap-2 text-sm text-gray-600 dark:text-gray-300">
                            <span className="text-plantlix-500 mt-0.5">✅</span>
                            <span>{benefit}</span>
                        </li>
                    ))}
                </ul>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 w-full max-w-xs">
                <button
                    onClick={() => navigate('/auth')}
                    className="w-full px-6 py-3 bg-plantlix-500 hover:bg-[#1e7e1e] text-white rounded-xl font-bold transition-all shadow-md active:scale-95"
                >
                    Account erstellen / Einloggen
                </button>
            </div>
        </div>
    );
};

export default GuestBlockedView;
